import { ReactComponent as Logo } from '@assets/icons/logo.svg';
import { styled } from '@withjoy/joykit';

export const ResizedLogo = styled(Logo)`
  width: auto;
  height: 40px;
`;
